import { useTranslations } from '@vocab/react';
import {
  Box,
  Columns,
  Column,
  Text,
  ButtonIcon,
  IconClear,
} from 'braid-design-system';
import { useId, type ComponentProps, type FC, type ReactElement } from 'react';

import translations from './.vocab';
import { IconVerifiedTransparent } from './IconVerifiedTransparent';

import * as styles from './styles.css';

interface SEEKPassAlertProps {
  iconSize: ComponentProps<typeof Text>['size'];
  onClose?: () => void;
  children: ReactElement;
  testId?: string;
}

export const SEEKPassAlert: FC<SEEKPassAlertProps> = ({
  iconSize,
  onClose,
  children,
  testId,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();
  return (
    <Box
      paddingY="medium"
      paddingX="gutter"
      borderRadius="large"
      background="customLight"
      className={styles.background}
      data={{ testid: testId || 'seek-pass-alert' }}
    >
      <Columns space="xsmall" alignY="top">
        <Column width="content">
          <Text size={iconSize}>
            <IconVerifiedTransparent />
          </Text>
        </Column>
        <Column>
          <Columns space="small">
            <Column>{children}</Column>
            {onClose ? (
              <Column width="content">
                <ButtonIcon
                  id={id}
                  label={t('Close')}
                  icon={<IconClear />}
                  variant="transparent"
                  onClick={onClose}
                />
              </Column>
            ) : null}
          </Columns>
        </Column>
      </Columns>
    </Box>
  );
};
